import { ErrorCode } from '@admin/utils/error-code/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useRoleMessageHandler = () => {
  const { t } = useTranslate()

  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)
    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      switch (errorDescription.code) {
        case ErrorCode.EntityNotFound:
          errors.push(
            t('entityNotFound', '{entity} with Id {id} not found', {
              entity: errorDescription.payload?.name,
              id: errorDescription.payload?.id,
            }),
          )
          break

        case ErrorCode.NameNotUnique:
          errors.push(
            t('specificiedFieldNotUnique', 'The value for {field} already exists', {
              field: t('name', 'name'),
            }),
          )
          break

        case ErrorCode.InsufficientPrivileges:
          errors.push(
            t(
              'insufficientPrivileges',
              'You do not have sufficient privileges to perform this action',
            ),
          )
          break

        default:
          break
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  const getSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('roleUpdatedSuccessfully', 'Role updated successfully')
      : t('roleCreatedSuccessfully', 'Role created successfully')
  }

  const getDeleteSuccessMessage = () => {
    return t('deleteRolesSuccess', 'Role(s) deleted successfully')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
    getDeleteSuccessMessage,
  }
}
